import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Logo } from "./Logo";
import { NavLinks } from "./NavLinks";
import {
  MobileMenuBackdrop,
  MobileMenuButton,
  MobileMenuPanel,
} from "./MobileMenu";

export const Navbar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 16);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-out ${
        isScrolled
          ? "bg-white md:bg-white/95 md:backdrop-blur-md border-b border-border-light shadow-[0_8px_24px_rgba(0,0,0,0.08)]"
          : "bg-white border-b border-border-light"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16 md:h-[72px] lg:h-24 relative">
          {/* Logo */}
          <Logo />

          {/* Desktop Navigation - Centered */}
          <NavLinks isActive={isActive} />

          {/* Mobile/Tablet Menu Button */}
          <MobileMenuButton
            isMobileMenuOpen={isMobileMenuOpen}
            setIsMobileMenuOpen={setIsMobileMenuOpen}
            isActive={isActive}
          />
        </div>

        {/* Mobile Menu */}
        <MobileMenuPanel
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          isActive={isActive}
        />
      </div>

      <MobileMenuBackdrop
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        isActive={isActive}
      />
    </nav>
  );
};

